import { useId } from "react";
import { cn } from "@/lib/utils";

// The SKIP mark: the skip-to-next ▶▶| stroke, drawn as a lane-dashed path.
//
// Inlined rather than `import mark from "@/assets/skip-mark.svg"` BECAUSE an
// <img> can't inherit `currentColor` — the mark has to take the brand blue (or
// the header's colour) from CSS, which only an inline SVG does. The geometry is
// kept in sync by hand with src/assets/skip-mark.svg, which stays the source of
// truth for the exported PNG/ICO favicons in public/.
//
// The mask id is per-instance (useId) so two marks on one screen — header and,
// say, an empty state — don't collide on a duplicate DOM id, which would make
// the second one render as a solid stroke with no lane dashes.
const MARK_PATH =
  "M84 36 C84 22 46 24 40 44 C36 56 48 58 60 60 C72 62 84 64 80 76 C74 96 36 98 36 84";

export function SkipMark({ className }: { className?: string }) {
  const maskId = useId();

  return (
    <svg
      viewBox="0 0 120 120"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="SKIP"
      // h-7 = 28px, the top of the 24–28px range the mark was drawn for. One
      // size everywhere; callers pass colour, not scale.
      className={cn("h-7 w-7 shrink-0", className)}
    >
      <mask id={maskId} maskUnits="userSpaceOnUse">
        <rect width="120" height="120" fill="#fff" />
        <path
          d={MARK_PATH}
          fill="none"
          stroke="#000"
          strokeWidth="3.6"
          strokeLinecap="round"
          strokeDasharray="8 9"
        />
      </mask>
      <path
        d={MARK_PATH}
        fill="none"
        stroke="currentColor"
        strokeWidth="22"
        strokeLinecap="round"
        strokeLinejoin="round"
        mask={`url(#${maskId})`}
      />
    </svg>
  );
}
